import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newExpense({ state }) {
    let expenseDetails = {
      expense_total: $(".expense_total").val(),
      account_id: $(".account_id").val(),
      expenses_date: $('.expenses_date').val(),
      expense_item: state.expense_item
    };
    
    $(".creatingExpense").hide();
    $(".creatingExpenseLoader").show();
    baseurl.post(rt.newExpense, expenseDetails).then(res => {
      $(".creatingExpense").show();
      $(".creatingExpenseLoader").hide();
      $(".form-control").val("");

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.expensesCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on creating data
        ers.errorCreatingExpenses();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadExpenses({ commit }) {
    baseurl.get(rt.loadExpenses).then(res => {
      $(".expensesLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //mutations
        commit("STORE_EXPENSES", res.data.expenses);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingExpenses();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
        commit("STORE_EXPENSES", []);
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }else if (res.data.code === 707) {
        //insufficient funds
        ers.PettycashBalance();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/expenses/actions.js